import { useContext, useState } from "react";
import IdCell from "layouts/users/user-list/components/IdCell";
import DefaultCell from "layouts/users/user-list/components/DefaultCell";

import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { NavLink } from "react-router-dom";
import { DataContext } from "context/dataContext";
import SnackbarAlert from "components/SnackbarAlert";
import DeleteConfirmationPopover from "components/DeleteConfirmationPopover";

const dataTableData = {
  columns: [
    { Header: "ID", accessor: "user_id", Cell: ({ value }) => <IdCell id={value} /> },
    {
      Header: "First Name",
      accessor: "user_first_name",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Last Name",
      accessor: "user_last_name",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Email",
      accessor: "user_email",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Type",
      accessor: "user_type",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    // {
    //   Header: "Premium",
    //   accessor: "premium",
    //   Cell: ({ value }) => <DefaultCell value={value} />,
    // },
    {
      Header: "Actions",
      accessor: "actions",
      width: 10,
      align: "right",
      Cell: ({ row }) => {
        const { deleteSingleUserApi } = useContext(DataContext);

        return (
          <>
            <MDBox display="flex" gap={2}>
              <MDButton
                size="small"
                variant="gradient"
                color="dark"
                component={NavLink}
                to={`/users/edit-user/${row.original.user_email}`}
              >
                Edit
              </MDButton>
              <DeleteConfirmationPopover
                heading="are you sure?"
                buttonText="Delete"
                DeleteFunction={() => {
                  deleteSingleUserApi(row.original.user_email);
                }}
              />
            </MDBox>
          </>
        );
      },
    },
  ],

  rows: [],
};

export default dataTableData;
